import { API, request } from './index'
import ottiResponse from '../jsons/ottiResponse.json'

export default class QuoteService {

  static async get(token, preview) {
    let URL = 'https://checkout.fivestarairways.com/api/quote' + '?token=' + token;

    if (preview) {
      URL += '&preview=' + preview
    }
    
    const response = await request.get(URL);

    return response.data
  }

  static async checkout(body) {

    const response = await request.post(API.checkout, body)

    return response.data
  }
}